import * as z from "zod";
import * as b from './baseSchemas';
import { standardSkillBook } from "./bookSchemas";
import { Book } from './bookSchemas';
export const bookConflicts = z.object({ books: z.array(standardSkillBook) });
const nameConflicts = z.record(z.string().ulid(), z.array(z.string()));
const otherConflicts = z.object({ other: z.array(z.string()) });
export const generalConflicts = z.object({ "conflicts": z.record(z.union([z.string().ulid(), z.literal('other')]), z.array(z.string())),
    books: z.array(standardSkillBook).nullish(),
});
export const generalConflictCollection = z.array(generalConflicts);
export const ConflictDatum = z.object({
    "conflicts": z.record(z.string(), z.array(z.string())),
    "books": z.union([z.array(Book), z.null()]).optional(),
});
export const ConflictArray = z.array(ConflictDatum);
